import { render } from "./AsignacionManualModal.vue?vue&type=template&id=6701696b"
import script from "./AsignacionManualModal.vue?vue&type=script&lang=js"
export * from "./AsignacionManualModal.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__